module.exports = __webpack_public_path__ + "img/hockey_logo.71bf4308.svg";